import { bus } from '@core/events/eventSystem';
import { getStore } from '@core/store';
import constants from '@core/utils/constants';
import { transformDealsResponse } from './serializers';

// Load list of deals
bus.on(constants.EVENTS.DEALS.LOAD, async (restaurantId) => {
  bus.emit(constants.EVENTS.DEALS.LOADING);
  const store = getStore('deals');
  store.state.loading = true;
  store.state.error = null;

  try {
    const url = restaurantId
      ? `${constants.ENDPOINTS.DEALS.LOAD}?restaurantId=${restaurantId}`
      : constants.ENDPOINTS.DEALS.LOAD;

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: 'load-deals',
      url,
      method: 'GET'
    });

    const dealsResponseHandler = (res) => {
      if (res.id === 'load-deals') {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, dealsResponseHandler);
        store.state.loading = false;
        if (res.success) {
          // Transform API data to component format
          const transformedDeals = transformDealsResponse(res.data);
          store.state.deals = transformedDeals;
          bus.emit(constants.EVENTS.DEALS.LOADED);
        } else {
          store.state.error = res.data?.message || 'Erreur lors du chargement';
          bus.emit(constants.EVENTS.DEALS.LOAD_ERROR, store.state.error);
        }
      }
    };
    bus.on(constants.EVENTS.NETWORK.RESPONSE, dealsResponseHandler);
  } catch (error) {
    store.state.loading = false;
    store.state.error = error.message;
    bus.emit(constants.EVENTS.DEALS.LOAD_ERROR, error.message);
  }
});

// Load single deal detail
bus.on(constants.EVENTS.DEALS.LOAD_DETAIL, async (dealId) => {
  const store = getStore('deals');
  store.state.loading = true;

  try {
    const url = constants.ENDPOINTS.DEALS.DETAIL(dealId);

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: `load-deal-detail-${dealId}`,
      url,
      method: 'GET'
    });

    const responseHandler = (res) => {
      if (res.id === `load-deal-detail-${dealId}`) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, responseHandler);
        store.state.loading = false;
        if (res.success) {
          store.state.currentDeal = res.data?.data;
          store.state.currentDealDishes = res.data?.data?.dishes || [];
          bus.emit('deals.detail_loaded', store.state.currentDeal);
        }
      }
    };
    bus.on(constants.EVENTS.NETWORK.RESPONSE, responseHandler);
  } catch (error) {
    store.state.loading = false;
  }
});

// Load dishes for a deal
bus.on(constants.EVENTS.DEALS.LOAD_DISHES, async (dealId) => {
  const store = getStore('deals');
  store.state.dishesLoading = true;

  try {
    const url = constants.ENDPOINTS.DEALS.DISHES(dealId);

    bus.emit(constants.EVENTS.NETWORK.REQUEST, {
      id: `load-deal-dishes-${dealId}`,
      url,
      method: 'GET'
    });

    const responseHandler = (res) => {
      if (res.id === `load-deal-dishes-${dealId}`) {
        bus.off(constants.EVENTS.NETWORK.RESPONSE, responseHandler);
        store.state.dishesLoading = false;
        if (res.success) {
          store.state.currentDealDishes = res.data?.data || [];
          bus.emit('deals.dishes_loaded', store.state.currentDealDishes);
        }
      }
    };
    bus.on(constants.EVENTS.NETWORK.RESPONSE, responseHandler);
  } catch (error) {
    store.state.dishesLoading = false;
  }
});
